"use client";

import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Dialog } from "../components/dialog.tsx";

import { useCalendarModalStore } from "@/features/calendar/store/useCalendarModalStore.tsx";
import { CreateSlotModal } from "@/features/calendar/components/create-slot/create-slot-modal.tsx";
import SlotEditModal from "@/features/calendar/components/slot-edit/slot-edit-modal.tsx";
import SlotDetailsModal from "@/features/calendar/components/slot-details/slot-details-modal.tsx";
import SlotReservationModal from "@/features/calendar/components/slot-reservation/slot-reservation-modal.tsx";
import useUserState from "@/hooks/useUserState.tsx";

export default function CalendarModal() {
  const { isOpen, setIsOpen, action, setSubjectsWithLevels } = useCalendarModalStore();
  const role = useUserState();
  const { workspaceId } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    console.log("123");
    if (role === "studentInWorkspace") {
      setSubjectsWithLevels(workspaceId ?? "", t);
    }
  }, []);

  const actionComponent = useMemo(() => {
    switch (action) {
      case "create":
        return <CreateSlotModal />;
      case "edit":
        return <SlotEditModal />;
      case "details":
        return <SlotDetailsModal />;
      case "reservation":
        return <SlotReservationModal />;
      default:
        return <CreateSlotModal />;
    }
  }, [action]);

  // @ts-ignore
  return (
    <Dialog open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      {actionComponent}
    </Dialog>
  );
}
